// Suppress annoying ResizeObserver loop errors that trigger React error overlay during development.
// This does NOT affect production – it only prevents the dev overlay from catching benign errors.
// More info: https://github.com/ag-grid/ag-grid/issues/5581

if (typeof window !== 'undefined') {
  const listener = (event: ErrorEvent) => {
    const msg = event?.message || '';
    if (
      msg.includes(
        'ResizeObserver loop completed with undelivered notifications',
      ) ||
      msg.includes('ResizeObserver loop limit exceeded')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };

  window.addEventListener('error', listener, true /* capture */);

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      const msg = (event.reason && event.reason.message) || '';
      if (
        msg.includes('ResizeObserver loop') ||
        msg.includes('ResizeObserver')
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
}

// Patch console.error to ignore repeated ResizeObserver errors that CRA overlays pick up.
const origConsoleError = console.error;
console.error = (...args: any[]) => {
  if (
    args.length &&
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  origConsoleError(...args);
};

export {};
